import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class LocalStorageService {
	private keyEventEmitters = new Map<string, Subject<any>>();

	public track<T>(key: string): Subject<T> {
		if (!this.keyEventEmitters.has(key)) {
			this.keyEventEmitters.set(key, new Subject<T>());
		}

		return this.keyEventEmitters.get(key);
	}

	private onValueChanged<T>(key: string, value: T) {
		if (this.keyEventEmitters.has(key)) {
			this.keyEventEmitters.get(key).next(value);
		}
	}

	public get<T>(key: string): T {
		const item: string = localStorage.getItem(key);
		
		return item ? JSON.parse(item) as T : null;
	}

	public set<T>(key: string, value: T): void {
		localStorage.setItem(key, JSON.stringify(value));

		this.onValueChanged(key, value);
	}

	public remove(key: string): void {
		localStorage.removeItem(key);

		this.onValueChanged(key, undefined);
	}

	public removeWithPrefix(prefix: string): void {
		for (let a = localStorage.length - 1; a >= 0; a--) {
			const key = localStorage.key(a);
			
			if (key.startsWith(prefix)) {
				localStorage.removeItem(key);

				this.onValueChanged(key, undefined);
			}
		}
	}

	public clear(): void {
		const storedCacheVersion = localStorage.getItem('cache-version');
		localStorage.clear();
		localStorage.setItem('cache-version', storedCacheVersion ? storedCacheVersion : '');
	}

	constructor() {}
}